import {
  evaluateFieldVisibility,
  evaluateNestedFieldConditions,
} from 'helpers/candidate_application/form-page-helpers';

export const getConsentsData = (formData, sectionKey, visibleSubsections, options = {}) => {
  const consentsData = [];
  const { allValues, fieldPathIndex = {} } = options;

  const processField = (field, subsectionCode) => {
    if (field?.consentField) {
      const item = {
        code: field.code,
        type: field.type,
        order: field.order,
        section_key: sectionKey,
        subsection_code: subsectionCode,
        text: field.text || field.title,
      };

      if (field.description) {
        item.description = field.description;
      }

      switch (field.type) {
        case 'signature':
          item.upload_id = formData[field.code];
          break;
        case 'pdf_preview':
          item.pdf_download_url = field.downloadUrl;
          break;
        case 'object':
          break;
        case 'statement':
          break;
        default:
          item.value = formData[field.code];
          break;
      }

      consentsData.push(item);
    }

    if (field?.type === 'object' && field.subFields?.length > 0) {
      field.subFields.forEach((subField, subFieldIndex) => {
        if (
          allValues != null &&
          !evaluateNestedFieldConditions(subField, field, allValues, fieldPathIndex, subFieldIndex)
        ) {
          return;
        }
        processField(subField, subsectionCode);
      });
    }
    const altIdGroups = field?.altIdFields || field?.alt_id_fields;
    if (Array.isArray(altIdGroups)) {
      altIdGroups.forEach(group => {
        (group.subFields || group.sub_fields || []).forEach((subField, subFieldIndex) => {
          if (
            allValues != null &&
            !evaluateNestedFieldConditions(
              subField,
              field,
              allValues,
              fieldPathIndex,
              subFieldIndex,
            )
          ) {
            return;
          }
          processField(subField, subsectionCode);
        });
      });
    }
  };

  visibleSubsections?.forEach(subsection => {
    const subsectionCode = subsection.code;
    subsection.fields?.forEach(field => {
      if (allValues != null && !evaluateFieldVisibility(field, allValues, fieldPathIndex)) {
        return;
      }
      processField(field, subsectionCode);
    });
  });

  return consentsData;
};
